import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * react-select Wrapper Component
 * https://react-select.com/home
 * NOTE: 型定義が複雑になることを避けるため isMulti, Option は false 固定
 * WARNING: isMulti, Option を別の型で定義する場合、別のコンポーネントを作成してください
 * WARNING: ライブラリ依存を避けるため、極力ページ内で直接SelectBaseを使用せず機能を制限した ui コンポーネントを作成し、それを利用してください
 */
import { forwardRef } from 'react';
import Select, { components as baseComponents } from 'react-select';
export const SelectBase = forwardRef((props, ref) => (_jsx(Select, Object.assign({}, props, { isMulti: false, ref: ref }))));
export const components = baseComponents;
